import { getCookieHunter } from "Common/cookies";
import { WebsocketProvider } from "y-websocket";
const domain = process.env.WS_SERVER_DOMAIN;
const port = process.env.WS_SERVER_PORT;
const prefix = process.env.WS_SERVER_PREFIX;
export const createProviderWebsocketProvider = (roomName, yDoc) => {
    const wsProtocol = window.location.protocol === "https:" ? "wss" : "ws";
    let wsUrl = `${wsProtocol}://${domain}`;
    if (port) {
        wsUrl = `${wsUrl}:${port}`;
    }
    if (prefix) {
        wsUrl = `${wsUrl}/${prefix}`;
    }
    const provider = new WebsocketProvider(wsUrl, roomName, yDoc, {
        protocols: ["Authorization", String(getCookieHunter())]
    });
    provider.on("status", event => {
        console.log("WebSocket status:", event.status);
    });
    provider.on("connection-error", error => {
        console.error("WebSocket connection error:", error);
    });
    return provider;
};
